import React from "react";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import {
    selectDeviceData,
    selectActiveEdgeDevices,
    selectDeviceDataDatasetStatus,
    selectDeviceDataDatasetVersionDttm,
    setActiveEdgeDeviceById,
} from "./store/reducers/deviceLinkingAppStoreSlice";
import DatasetDerivedList from "./DatasetDerivedList";

type DeviceListProps = {
    className?: string;
};

export default function DeviceList(props: DeviceListProps): JSX.Element {
    const dispatch = useAppDispatch();
    const dataset = useAppSelector(selectDeviceData);
    const datasetStatus = useAppSelector(selectDeviceDataDatasetStatus);
    const datasetVersion = useAppSelector(selectDeviceDataDatasetVersionDttm);

    const activeEdgeDevices = useAppSelector(selectActiveEdgeDevices);
    return (
        <DatasetDerivedList
            className={props.className}
            dataNotYetLoadedMessage="No data loaded. Select a Client & Project to continue"
            emptyListMessage="No devices in dataset"
            errorMessage="No devices in dataset"
            datasetStatus={datasetStatus}
            datasetType={dataset?.meta?.dataset_type || ""}
            datasetVersion={datasetVersion || ""}
            selectObject={(device) => device && dispatch(setActiveEdgeDeviceById(device.edge_device_id))}
            isActiveObject={(device) => activeEdgeDevices.indexOf(device) !== -1}
            objectList={dataset?.data.devices || []}
            extractObjectKey={(device) => device.edge_device_id.toString()}
            extractObjectLabel={(device) =>
                `Site ${device.site_id} / ${device.edge_device_id} / ${device.cloudgate_serial_no}`
            }
            sortByLabel={true}
        />
    );
}
